import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../../services';
import { DashboardTrackingActions, ModernDashboardTrackingActions } from './dashboard-tracking.actions';


@Injectable()
export class DashboardTrackingEffects {
  

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {
  }


  loadDashboardTracking$ = createEffect(() =>
      this.actions$.pipe(
        ofType(DashboardTrackingActions.load),
        mergeMap(({period}) =>
          this.api.getDashboardStatisticsData(period).pipe(
            map((response) => {

              return DashboardTrackingActions.loadSuccess({ dashboardTracking: response });
            }), // Add closing parenthesis here
            catchError((error) => of(DashboardTrackingActions.loadFailure({ error })))
          )
        )
      )
    );

       loadModernDashboardTracking$ = createEffect(() =>
      this.actions$.pipe(
        ofType(ModernDashboardTrackingActions.load),
        mergeMap(() =>
          this.api.getDashboardModernStats().pipe(
            map((response) => {

              return ModernDashboardTrackingActions.loadSuccess({ dashboardTracking: response });
            }), // Add closing parenthesis here
            catchError((error) => of(ModernDashboardTrackingActions.loadFailure({ error })))
          )
        )
      )
    );
  
}
